<template>
  <v-container class="gdpr-page">
    <v-row class="d-flex justify-center">
      <v-col cols="12">
        <page-header>{{ $t('gdpr.meta_description') }}</page-header>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center" v-for="(section, index) in sections" :key="index">
      <v-col cols="12">
        <div class="title-section text-h5" v-html="$t('gdpr.section' + section + '_title')"></div>
        <div class="text-section text-body-1" v-html="$t('gdpr.section' + section + '_text')"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeader from '@/components/PageHeader';

export default {
  name: 'Gdpr',
  components: {
    PageHeader,
  },
  data: function () {
    return {
      sections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    }
  }
}
</script>

<style scoped>
.text-section, .title-section {
  white-space: pre-wrap;
}

.gdpr-page {
  max-width: 1000px;
}
</style>
